var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enableByDefaultReset)?_c('div',{staticClass:"clear-filters"},[_c('a',{staticClass:"clear-fields-filter",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_c('i',{staticClass:"si si-cross"}),_vm._v(" Clear all filters ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }